import { Component } from '@hatiolab/things-scene'

import ControlBase, { DIRECTION, INOUT, NODE, PIPELINE } from './base/control-base'

const IMAGE = new URL('../icons/document-message.png', import.meta.url).href

const NATURE = {
  mutable: false,
  resizable: false,
  rotatable: false,
  properties: [],
  help: '/eipatterns/document-message/document-message'
}

export default class DocumentMessage extends ControlBase {
  static IMAGE: HTMLImageElement

  static get nature() {
    return NATURE
  }

  get nodes(): NODE[] {
    return [
      {
        name: 'In',
        description: 'Message inlet',
        inout: INOUT.IN,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.WEST,
        multiplicity: 1
      },
      {
        name: 'Out',
        description: 'Message outlet',
        inout: INOUT.OUT,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.EAST
      }
    ]
  }

  getImageElement(): HTMLImageElement {
    if (!DocumentMessage.IMAGE) {
      DocumentMessage.IMAGE = new Image()
      DocumentMessage.IMAGE.src = IMAGE
    }

    return DocumentMessage.IMAGE
  }
}

Component.register('document-message', DocumentMessage)
